import { createApp } from 'vue'
import SearchHistoryService from '@/services/searchHistoryService';
import NewsOverview from './news-overview.vue';


document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('newsOverviewContainer');
    if (!el) return

    SearchHistoryService.create();
    const app= createApp(NewsOverview);
    app.mount( el );
})

